import type { SVGProps } from "react";
import * as React from "react";

const SvgEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 5a1 1 0 1 0 0-2zM4 4V3zM2 6H1zm0 14H1zm19-7a1 1 0 1 0-2 0zM18.5 2.5l-.707-.707zm1.5-.621v-1zM21.5 5.5l-.707-.707zM12 15l.242.97a1 1 0 0 0 .465-.263zm-4 1-.97-.242a1 1 0 0 0 1.213 1.212zm1-4-.707-.707a1 1 0 0 0-.263.465zm2-9H4v2h7zM4 3a3 3 0 0 0-2.121.879l1.414 1.414A1 1 0 0 1 4 5zm-2.121.879A3 3 0 0 0 1 6h2a1 1 0 0 1 .293-.707zM1 6v14h2V6zm0 14a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 3 20zm.879 2.121A3 3 0 0 0 4 23v-2a1 1 0 0 1-.707-.293zM4 23h14v-2H4zm14 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 18 21zm2.121-.879A3 3 0 0 0 21 20h-2a1 1 0 0 1-.293.707zM21 20v-7h-2v7zM19.207 3.207c.21-.21.496-.328.793-.328v-2c-.828 0-1.622.329-2.207.914zM20 2.88c.297 0 .583.118.793.328l1.414-1.414A3.12 3.12 0 0 0 20 .879zm.793.328c.21.21.328.496.328.793h2c0-.828-.328-1.622-.914-2.207zM21.12 4c0 .297-.118.583-.328.793l1.414 1.414c.585-.585.914-1.38.914-2.207zm-.328.793-9.5 9.5 1.414 1.414 9.5-9.5zm-9.035 9.237-4 1 .485 1.94 4-1zM8.97 16.243l1-4-1.94-.486-1 4zm.737-3.536 9.5-9.5-1.414-1.414-9.5 9.5z"
    />
  </svg>
);
export default SvgEdit;
